<template>
<div class="comments_list_wrapper">
    <div class="comments_list" v-if="commentList.length !== 0">
        <div class="comments_list_card main" v-for="(comment, index) in commentList" :key="'comment_'+index" :data-order="index">
            <div class="card_avatar">
                <img :src="comment.sehseh.avatar" alt="" class="card_avatar_img">
            </div>
            <div class="card_content">
                <p class="card_name">
                    <span class="name_text">{{comment.sehseh.nickname}}</span>
                </p>
                <p class="card_text">{{comment.content}}</p>
                <p class="card_time">{{$parent.convertTimestampToFormat(comment.created_at)}}</p>
            </div>
        </div>
<!--            <div class="comments_list_card reply">-->
<!--                <div class="card_avatar">-->
<!--                    <img src="https://s3-ap-northeast-1.amazonaws.com/smg-app-resources/user.png" alt="" class="card_avatar_img">-->
<!--                </div>-->
<!--                <div class="card_content">-->
<!--                    <p class="card_name">-->
<!--                        <span class="name_text">閻紀宇</span>-->
<!--                        <span class="name_desc">作者</span>-->
<!--                    </p>-->
<!--                    <p class="card_text">青山依舊在，幾度夕陽紅。慣看秋月春風。一壺濁酒喜相逢，浪花淘盡英雄。是非成敗轉頭空，滾滾長江東逝水，白髮漁樵江渚上，古今多少事，都付笑談中。😍🔥</p>-->
<!--                    <p class="card_time">Apr 29, 2021, 11:40</p>-->
<!--                </div>-->
<!--            </div>-->
    </div>
    <div class="comments_list" v-else>
        <div class="card_content">
            <p class="card_text no_content" v-if="initLoading">載入中...</p>
            <p class="card_text no_content" v-else-if="!initLoading && total === 0">暫時沒有評論，成為第一篇評論者</p>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        props: {
            commentList: {
                type: Array
            },
            initLoading: {
                type: Boolean,
                default: true
            },
            total: {
                type: Number,
                default: 0
            }
        }
    }
</script>